'use client'

import { useQuery } from '@tanstack/react-query'
import { isNil } from 'lodash-es'
import { useParams } from 'next/navigation'
import { useCallback } from 'react'

import { contractQueries, TDepositReturnAccount } from '@/entities/contract'

type Props = {
  contractId?: number
}

export const useGuestDepositReturnAccount = ({
  contractId: contractIdProp,
}: Props = {}) => {
  const params = useParams()
  const contractId = Number(params?.contractId)

  const {
    data: depositReturnAccount,
    isError,
    error,
  } = useQuery({
    ...contractQueries.guestDepositReturnAccount({
      contractId: contractIdProp ?? contractId,
    }),
    enabled: false,
    meta: {
      useCustomHandling: true,
    },
  })

  const hasDepositReturnAccount = useCallback(
    (account?: TDepositReturnAccount): account is TDepositReturnAccount =>
      !isNil(account) && !isNil(account.depositReturnBankAccount),
    [],
  )

  return {
    hasDepositReturnAccount,
    depositReturnAccount,
    isError,
    error,
  }
}
